export function getAvailableCarMarketPosition(
  apiIndex: number,
  queryOriginalPriceIndex: number,
  pageOffset: number
): number {
  return apiIndex < queryOriginalPriceIndex ? apiIndex + 1 + pageOffset : apiIndex + 2 + pageOffset;
}
